<div
  *ngIf="!fieldAttribute.hidden"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
  class="single-select-container"
>
  <label
    [for]="fieldAttribute.id"
    class="form-label label"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
    (click)="$event.preventDefault()"
  >
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
    <div
      *ngIf="isMobileView && isShowInfoTooltip"
      class="ms-1 custom-tooltip"
      data-test-id="info-tooltip"
      placement="bottom auto"
      [ngbTooltip]="fieldAttribute.backendAttribute.placeholder | translate"
      triggers="click:blur"
    >
      <img src="assets/icons/icon-info.svg" alt="info" />
    </div>
  </label>
  <input
    appToggleOverflow
    [class.is-invalid]="isFieldInvalid()"
    [ngClass]="fieldAttribute.elementStyles.contentStyle"
    [class.disabled-control]="isControlDisabled()"
    [disabled]="isControlDisabled()"
    type="text"
    [id]="fieldAttribute.id"
    [attr.data-test-id]="fieldAttribute.elementDataTestId"
    [placeholder]="(isMobileView ? newPlaceholder : fieldAttribute.backendAttribute.placeholder) | translate"
    #typehead="ngbTypeahead"
    [(ngModel)]="selectedItem"
    [ngbTypeahead]="search"
    [inputFormatter]="formatter"
    [resultTemplate]="suggestionsTemplate"
    (focus)="focus$.next($event.target.value)"
    (click)="click$.next($event.target.value)"
    (selectItem)="onSelectedItem($event)"
    (input)="onInput($event.target.value)"
    (blur)="onBlur()"
  />
  <ng-template #suggestionsTemplate let-result="result" let-t="term">
    <ngb-highlight [result]="result.title | translate" [term]="t"></ngb-highlight>
  </ng-template>
  <div class="d-flex">
    <small
      *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
      class="d-flex mt-1 invalid-feedback"
      [attr.data-test-id]="fieldAttribute.errorDataTestId"
    >
      {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
    </small>
    <app-counter
      *ngIf="
        !fieldAttribute.backendAttribute.counter_hide &&
        fieldAttribute.backendAttribute.max_length &&
        !fieldAttribute.backendAttribute.read_only
      "
      class="ms-auto mt-1"
      [maxLength]="fieldAttribute.backendAttribute.max_length"
      [isFieldInvalid]="fieldAttribute.backendAttribute.max_length < controlValueLength"
      [dataTestId]="fieldAttribute.elementDataTestId"
      [valueLength]="controlValueLength"
    >
    </app-counter>
  </div>
</div>
